import * as PIXI from "pixi.js";
import Game from "../Game";
import Layers from "../layers/Layers";


export default class YCCircle extends PIXI.Graphics {
  Game = Game.getInstance();
  Layers = Layers.getInstance();

  constructor() {
    super();
    this.draw();
    this.followPointer();
    this.addToLayer();
  }
  private addToLayer = () => this.Layers.VideoMode.addChild(this);

  draw() {
    this.circle(0, 0, 20)
      .fill("yellow")
      .alpha = .5
  }
  followPointer() {
    this.Layers.UI.on("pointermove", e => {
      this.position.copyFrom(e.data.global);
    })
  }
}